<template>
  <div class="layouts">
    <div class="nav_content">
      <div class="left" @click="back"><i class="el-icon-arrow-left"></i></div>
      <div class="title">{{ lang.gywm }}</div>
    </div>
  </div>

</template>

<script type="text/javascript">
import store from "../store";
import { CONF,API_SERVER } from '@/assets/js/config'
import {mapState} from "vuex";

export default {
  data() {
    return {
      apiSer: "",
      radio: CONF.LANG ,
    }
  },
  computed: {
    ...mapState(['lang'])
  },

  methods: {
    back(){
      this.$router.back()
    },
    selectLang(){
      CONF.LANG = this.radio
      this.$indicator.open(this.lang.loading);
      sessionStorage.removeItem('lang')
      sessionStorage.setItem('lang', this.radio)
      this.$xhrGet('/system/translate').then(res => {
        store.state.lang = res.data
        this.$indicator.close();
        store.commit("SET_TRANSLATE",res.data)
        this.back()
      })

    },
  }
}
</script>


<style>
.layouts{
  background: #000;
  color: #fff;
  height: 100%;
  padding: 0 20px;
}
.nav_content {
  padding:20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.nav_content .left{
  position: absolute;
  left: 20px;
  font-size: 20px;
  font-weight: 600;
}
.nav_content .title{
  font-size: 20px;
  font-weight: 600;
}

</style>
